import { render, staticRenderFns } from "./RadiologyImageResults.vue?vue&type=template&id=4cc2d0c0&"
import script from "./RadiologyImageResults.vue?vue&type=script&lang=js&"
export * from "./RadiologyImageResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports